import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const serviceTemplateService = {
    getAllserviceTemplates,
    getserviceTemplate,
    updateserviceTemplate,
    createserviceTemplate,
    updateserviceTemplateStatus,
};

const MODULE = {
    SERVICE: 'service-templates',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllserviceTemplates(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.SERVICE}`, requestOptions)
}

export function getserviceTemplate(id) {
    return apiHelper(API_URL).get(`/${MODULE.SERVICE}/${id}`)
}

export function updateserviceTemplate(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'service_type_uuid', data.serviceTypeID);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    sharedHelper.appendIfNotNull(formData, 'after_service_description', data.afterServiceDescription);
    sharedHelper.appendIfNotNull(formData, 'price_type_id', data.priceTypeID);
    sharedHelper.appendIfNotNull(formData, 'price', data.price);
    sharedHelper.appendIfNotNull(formData, 'rebook_day_after_service', data.rebookDayAfterService);
    sharedHelper.appendIfNotNull(formData, 'duration_minutes', data.durationMinutes);
    formData.append('_method', 'PUT');

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    if (data.isRebookNeeded != "" && data.isRebookNeeded == true) {
        formData.append('is_rebook_needed', 1);
    }
    else {
        formData.append('is_rebook_needed', 0);
    }

    if (data.image instanceof File) {
        formData.append('image', data.image);
    }

    return apiHelper(API_URL).post(`/${MODULE.SERVICE}/${data.id}`, formData)
}

export function createserviceTemplate(data) {
    const formData = new FormData();

    data.forEach((template, index) => {

        formData.append(`template[${index}][service_type_uuid]`, template.serviceTypeID.value);
        formData.append(`template[${index}][description]`, template.description);
        formData.append(`template[${index}][after_service_description]`, template.afterServiceDescription);
        formData.append(`template[${index}][price]`, template.price);
        formData.append(`template[${index}][price_type_id]`, template.priceTypeID);
        formData.append(`template[${index}][rebook_day_after_service]`, template.rebookDayAfterService);
        formData.append(`template[${index}][duration_minutes]`, template.durationMinutes);

        if(template.isRebookNeeded != null && template.isRebookNeeded == true) {
            formData.append(`template[${index}][is_rebook_needed]`, 1);
        }
        else {
            formData.append(`template[${index}][is_rebook_needed]`, 0);
        }

        if (template.image instanceof File) {
            formData.append(`template[${index}][image]`, template.image);
        }

        template.names.forEach((name, index) => {
            formData.append(`template[${index}][name][${index}][language_code]`, name.language.code);
            formData.append(`template[${index}][name][${index}][value]`, name.name);
        });

    });

    return apiHelper(API_URL).post(`/${MODULE.SERVICE}`, formData)
}

export function updateserviceTemplateStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.SERVICE}/${data.id}`, requestOptions)
}